module.exports = __webpack_public_path__ + "static/media/ico-others-options.c3f278a0.svg";